/**
 * 最近一次报名单的本地记忆
 * -----------------------------------------------------------------------------
 * 存在的原因是一个**契约缺口**：服务端只提供 `GET /api/h5/registrations/{id}`，
 * 没有「我的报名单列表」端点（openapi 声明了 `/api/h5/inbox` 等，但未实现）。
 * 于是首页 / 报名记录页只能靠本地记住的那一个 id 去拉详情。
 * 这是降级方案，不是设计目标 —— 已在交付说明的「未闭合项」中登记。
 */
const KEY = 'enroll.recentRegistrationIds';

export function rememberRegistration(id: string): void {
  try {
    const list = readRecentRegistrations().filter((item) => item !== id);
    list.unshift(id);
    window.sessionStorage.setItem(KEY, JSON.stringify(list.slice(0, 10)));
  } catch {
    // 存储不可写：仅丢失「首页快捷入口」，不影响主链路
  }
}

export function readRecentRegistrations(): string[] {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((item): item is string => typeof item === 'string')
      : [];
  } catch {
    return [];
  }
}

export function lastRegistrationId(): string | null {
  return readRecentRegistrations()[0] ?? null;
}
